'use strict';

var React = require('react');

var SvgRedoMajor = function SvgRedoMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M16.512 5c-2.149-1.934-3.99-3-6.512-3a8 8 0 0 0-8 8 8 8 0 0 0 8 8 1 1 0 1 1 0 2c-5.523 0-10-4.477-10-10s4.477-10 10-10c3.297 0 5.644 1.496 8 3.647v-2.647a1 1 0 1 1 2 0v5a.998.998 0 0 1-.29.705l-.005.004a.997.997 0 0 1-.705.291h-5a1 1 0 1 1 0-2h2.512z"
  }));
};

exports.SvgRedoMajor = SvgRedoMajor;
